import { useApiPost } from 'src/api';
import { useBuildVars } from 'src/config';
import { useApiHeaders } from 'src/views/bidManagementHub/hooks/apiheader';
import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { ColumnFilter } from 'src/components/TableComponent/types';

type ViwSagetransctionEvent = {
  author: string;
  content_text: string;
  country_code: string;
  invocation_id: string;
  session_id: string;
  timestamp: string;
  user_id: string;
};

export type ViwSagetransctionResponse = {
  events: ViwSagetransctionEvent[];
  page: number;
  page_size: number;
  total_events: number;
  total_pages: number;
};

type SageFilterRequest = {
  filters: {
    field: string;
    operator: string;
    value: string | string[];
  }[];
};

export type SageTransactionsRequest = {
  page: number;
  page_size: number;
  sortColumn?: string;
  sortDirection?: 'asc' | 'desc';
} & Partial<SageFilterRequest>;

export const sageFilterQueryGenerator = (filters?: ColumnFilter) => {
  const filterRequest: SageFilterRequest = { filters: [] };

  if (!filters) return filterRequest;

  for (const key of Object.keys(filters)) {
    const filter = filters[key];
    if (filter === null) continue;
    filterRequest.filters.push({
      field: key,
      operator: filter.action,
      value: filter.value,
    });
  }

  return filterRequest;
};

export function useGetViwSagetransctionlist(query: SageTransactionsRequest) {
  const buildVars = useBuildVars();
  const headers = useApiHeaders();
  const apiPost = useApiPost<ViwSagetransctionResponse>({
    host: buildVars.CHAT_API_BASE,
  });

  const mutation = useMutation(() =>
    apiPost(`/sage/v1/sageagent/sageevents`, query, undefined, headers)
  );

  useEffect(() => {
    mutation.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(query)]);

  return mutation;
}
